import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/booking/download.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var downloadFile = (data, fileName) => {
  const blob = new Blob([data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${fileName}.pdf`);
  document.body.appendChild(link);
  link.click();
};
var downloadTicket = (_0) => __async(void 0, [_0], function* ({ orderId, title, lang }) {
  var _a, _b;
  try {
    const lan = getLocaleOnly(lang);
    const response = yield fetchClient({
      url: `/download/event/tickets?lang=${lan}&source=${(_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource}`,
      options: {
        method: "POST",
        body: JSON.stringify({
          order_id: orderId
        })
      },
      raw: true
    });
    const blob = yield response.blob();
    downloadFile(blob, title);
  } catch (error) {
    throw new Exception({
      error,
      name: "downloadTicketException"
    });
  }
});
var downloadReceipt = (_0) => __async(void 0, [_0], function* ({ orderId, title, lang }) {
  var _a, _b;
  try {
    const lan = getLocaleOnly(lang);
    const response = yield fetchClient({
      url: `/download/event/receipts?lang=${lan}&source=${(_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource}`,
      options: {
        method: "POST",
        body: JSON.stringify({
          order_id: orderId,
          lang: lan
        })
      },
      raw: true
    });
    const blob = yield response.blob();
    downloadFile(blob, title);
  } catch (error) {
    throw new Exception({
      error,
      name: "downloadReceiptException"
    });
  }
});
var downloadSubscription = (_0) => __async(void 0, [_0], function* ({ orderId, title, lang }) {
  var _a, _b;
  try {
    const lan = getLocaleOnly(lang);
    const response = yield fetchClient({
      url: `/subscriptions/download-invoice?lang=${lan}&source=${(_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource}`,
      options: {
        method: "POST",
        body: JSON.stringify({
          user_subscription_id: orderId,
          lang: lan
        })
      },
      raw: true
    });
    const blob = yield response.blob();
    downloadFile(blob, title);
  } catch (error) {
    throw new Exception({
      error,
      name: "downloadSubscriptionException"
    });
  }
});

export {
  downloadTicket,
  downloadReceipt,
  downloadSubscription
};
//# sourceMappingURL=chunk-MYAVF3P2.mjs.map